import { render, staticRenderFns } from "./CCDashboard.vue?vue&type=template&id=0687b8c4"
import script from "./CCDashboard.vue?vue&type=script&lang=js"
export * from "./CCDashboard.vue?vue&type=script&lang=js"
import style0 from "./CCDashboard.vue?vue&type=style&index=0&id=0687b8c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports